export const faqs = [
  {
    id: 1,
    question:
      "My child’s exam only involves maths and English.  Can i only sign up for those two courses?",
    answer:
      "Yes you can! we offer a variety of teaching schedules so you can have the freedom to decide the course(s) you want your child to take to tailor their tuition to their specific exam preparation needs ",
  },
  {
    id: 2,
    question: "What feedback will I receive about my childs learning?",
    answer:
      "Tutors make notes at the eand of each lesson, these combined with homework performance are compiled and will be sent out to parents every month.",
  },
  {
    id: 3,
    question:
      "My child is not taking the 11+ exam. Can they still benefit from taking some of the courses?",
    answer:
      "Yes they can! Our courses provide students with learning skills that last a lifetime! Whether your child is taking the 11+ exam or not, the numerical, reasoning and all the other skills gained in these courses will definitely give them a headstart in secondary school!",
  },
  {
    id: 4,
    question: "Do you offer in-person lessons?",
    answer:
      "At the moment, all of our lessons are delivered online, and we do not offer in-person sessions. This allows for greater flexibility, convenience, and the ability to learn from the comfort of your own home, wherever you are.",
  },
];
